var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");

var ShapeWrapperInteractionModel = require("./../../shapeWrapperViewer/shapeWrapperInteractionModel.js");

var RestrictInteractionModel = function (data, editorModel) {
    var self = this;

    ShapeWrapperInteractionModel.apply(this, arguments);

    this.editorModel = editorModel;
    this.layerStackMap = new lib_core.Collections.HashMap();

    if(this.data.parentCollection[0].getName() != "viaRestricts") {
        //Hacky
        if(this.editorModel.constructor.name == "EditorPCBModel") {

            this.showLayer = this.shadow("showLayer",
                function () {
                    var metalLayer = this.editorModel.metalLayers.get(this.data.layerIndex.getOne())
                    return metalLayer && metalLayer.name;
                },
                function (value) {
                    this.data.layerIndex.removeAll();
                    this.data.layerIndex.add(this.layerStackMap.get(value));
                },
                [this.data.layerIndex]
            );
        }else {
            this.showLayer = this.shadow("showLayer",
                function () {
                    switch (this.data.layerIndex.getOne()) {
                        case 0:
                            return cio_datamodel.FootprintLayers.TOP;
                        case cio_datamodel.FootprintLayers.INNER:
                            return cio_datamodel.FootprintLayers.INNER;
                        case 1:
                            return cio_datamodel.FootprintLayers.BOTTOM;
                    }
                },
                function (value) {
                    this.data.layerIndex.removeAll();
                    if (value == cio_datamodel.FootprintLayers.TOP) this.data.layerIndex.add(0);
                    else if (value == cio_datamodel.FootprintLayers.INNER) this.data.layerIndex.add(cio_datamodel.FootprintLayers.INNER);
                    else if (value == cio_datamodel.FootprintLayers.BOTTOM) this.data.layerIndex.add(1);
                },
                [this.data.layerIndex]
            );
        }
    }
};
lib_core.inherit(RestrictInteractionModel, ShapeWrapperInteractionModel);
RestrictInteractionModel.$class = "RestrictInteractionModel";

module.exports = RestrictInteractionModel;

RestrictInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new editor_2d.SnapSet();

    return snapSet;
};

RestrictInteractionModel.prototype.getInspectorElements = function () {
    var self = this;
    var shapeInspectorElements = this.shapeInteractionModel().getInspectorElements();
    var inspectorElements = {input_elements: []};

    var layerList = [];
    //This is kinda hacky, want a better way to give different behavior depending
    //on the editor this tool is being used in.
    if(this.editorModel.constructor.name == "EditorPCBModel") {
        if(this.data.parentCollection[0].getName() == "copperRestricts") {
            this.editorModel.circuitData.pcbData().layerStack().forEach(function (ind, layer) {
                var layerName = self.editorModel.metalLayers.get(layer).name;
                layerList.push(layerName);
                self.layerStackMap.put(layerName, layer);
            });
        }else{
            self.layerStackMap.put(this.editorModel.metalLayers.get(0).name, 0);
            self.layerStackMap.put(this.editorModel.metalLayers.get(1).name, 1);
            layerList = [this.editorModel.metalLayers.get(0).name, this.editorModel.metalLayers.get(1).name];
        }
    }else {
        layerList = [cio_datamodel.FootprintLayers.TOP, cio_datamodel.FootprintLayers.BOTTOM];
        if (this.data.parentCollection[0].getName() == "copperRestricts") layerList.splice(1, 0, cio_datamodel.FootprintLayers.INNER);
    }

    if(this.showLayer) {
        inspectorElements.input_elements.push({
            label: 'Layer',
            type: ui_extensions.InspectorInputType.SELECTBOX,
            list: layerList,
            datamember: this.showLayer,
        });
    }

    shapeInspectorElements.input_elements.forEach(function (el) {
        if (el.label !== 'Fill' &&
            el.label !== 'Stroke Width' &&
            el.label !== 'Expand') {
            inspectorElements.input_elements.push(el);
        }
    });

    var typeName;
    switch(this.data.parentCollection[0].getName()) {
        case "copperRestricts" :
            typeName = "Copper";
            break;
        case "viaRestricts" :
            typeName = "Via";
            break;
        case "componentRestricts" :
            typeName = "Component";
            break;
    }
    inspectorElements.help_elements = {
        'name': typeName + ' Restrict ' + shapeInspectorElements.help_elements['name']
    };

    return inspectorElements;
};
